import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import partners from '../assets/partners.png';

import { IoMdCheckmarkCircleOutline, IoMdTrophy } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import { GiCheckMark } from "react-icons/gi";
import logo from '../assets/logo_icon.png';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { MdLightbulbOutline } from "react-icons/md";


export default function HomeBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}
	

	useEffect(() => {
		init();
	}, []);
	
	useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: false,
    });
  }, []);

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if (ready) {
		return (
			<div className="MainBodySection">
				<div
					style={{
						width: "100%",
						height: "auto",
						position: "relative",
						overflow:"auto"
					}}
				>
					{banners.map((banner, i) => (
						<div
							key={i}
							style={{
								backgroundImage: `url(${banner})`,
								backgroundAttachment: "fixed",
								backgroundSize: "cover",
								backgroundPosition: "center",
								width: "100%",
								height: "100%",
								position: "absolute",
								top: 0,
								left: 0,
								transition: "opacity 1.5s ease-in-out",
								opacity: i === bgIndex ? 1 : 0,
							}}
						/>
					))}

					{/* gradient overlay */}
					<div
						style={{
							width: "100%",
							height: "100%",
							background: "rgba(0, 0, 0, 0.5)",
							position: "relative",
							zIndex: 1
						}}
					>
						
						<div className="container">
								<div className="row py-5">

									<div className="col-md-12 text-center mb-5">
										<img src={logo} height={100} />
									</div>
								
									<div className="row g-4 mt-3">
										{/* Vision */}
										<div className="col-md-4">
											<div className="h-100 p-4 rounded-3 shadow-sm" style={{ background: '#ffffff', border: '1px solid #e2e8f0' }}>
											<div className="text-center mb-4">
												<span className="d-inline-block px-3 py-1 rounded-pill bg-primary-subtle text-primary fw-semibold mb-3" style={{ fontSize: '0.875rem' }}>
												Vision
												</span>
												<h3 className="h5 fw-bold text-dark mb-3">Supporting Africa’s Transformation</h3>
												<div className="w-12 bg-primary mx-auto" style={{ height: '2px' }}></div>
											</div>
											<p className="text-muted mb-0" style={{ lineHeight: 1.6, fontSize: '1rem' }}>
												To support the transformation of African economies through consulting that drives sustainable development.
											</p>
											</div>
										</div>

										{/* Mission */}
										<div className="col-md-4">
											<div className="h-100 p-4 rounded-3 shadow-sm" style={{ background: '#ffffff', border: '1px solid #e2e8f0' }}>
											<div className="text-center mb-4">
												<span className="d-inline-block px-3 py-1 rounded-pill bg-success-subtle text-success fw-semibold mb-3" style={{ fontSize: '0.875rem' }}>
												Mission
												</span>
												<h3 className="h5 fw-bold text-dark mb-3">Guided by Evidence, Driven by Impact</h3>
												<div className="w-12 bg-success mx-auto" style={{ height: '2px' }}></div>
											</div>
											<p className="text-muted mb-0" style={{ lineHeight: 1.6, fontSize: '1rem' }}>
												To provide governments, organisations, and communities with guidance and data-driven insights through research, evaluations, and advisory services.
											</p>
											</div>
										</div>

										{/* Values */}
										<div className="col-md-4">
											<div className="h-100 p-4 rounded-3 shadow-sm" style={{ background: '#ffffff', border: '1px solid #e2e8f0' }}>
											<div className="text-center mb-4">
												<span className="d-inline-block px-3 py-1 rounded-pill bg-info-subtle text-info fw-semibold mb-3" style={{ fontSize: '0.875rem' }}>
												Values
												</span>
												<h3 className="h5 fw-bold text-dark mb-3">Our Values</h3>
												<div className="w-12 bg-info mx-auto" style={{ height: '2px' }}></div>
											</div>
											<ul className="list-unstyled text-muted mb-0" style={{ lineHeight: 1.7, fontSize: '1rem' }}>
												<li className="d-flex align-items-start mb-2">
												<span className="me-2">•</span> <span>Intellectual honesty</span>
												</li>
												<li className="d-flex align-items-start mb-2">
												<span className="me-2">•</span> <span>Integrity</span>
												</li>
												<li className="d-flex align-items-start mb-2">
												<span className="me-2">•</span> <span>Client focus</span>
												</li>
												<li className="d-flex align-items-start mb-2">
												<span className="me-2">•</span> <span>Ethical conduct</span>
												</li>
												<li className="d-flex align-items-start">
												<span className="me-2">•</span> <span>Continuous learning</span>
												</li>
											</ul>
											</div>
										</div>
										</div>
								</div>							
							</div>						
					</div>
				</div>
				
				<div className="container my-5">
					<h3 className="text-primary font-semi-bold">
						Our Partners
					</h3>
					<h6 className="my-3">
						We collaborate with organisations across Africa involved in social and economic development.
					</h6>
					<img style={{width:"100%"}} src={partners} />
				</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
